import React, { useRef } from "react";
import { Dropdown, Image } from "react-bootstrap";
import placeholderImg from "../../assets/images/dummyPlaceholder.jpg";
import certificateBg from "../../assets/images/certificate-bg.png";
import html2canvas from "html2canvas";
import jsPDF from "jspdf";
import certificateLogo from "../../assets/images/certificate-logo.png";
import awardImg from "../../assets/images/award.png";
import EgwbSignature from "../../assets/images/Egwb-signature.png";

const StudentCertificateDetailComponent = ({ certificate }) => {
  const certificateRef = useRef(null);
  const statsRef = useRef(null);

  const handleDownloadStats = async () => {
    if (!statsRef.current) return;

    try {
      const canvas = await html2canvas(statsRef.current, {
        scale: 2,
        useCORS: true,
        backgroundColor: "#ffffff",
      });

      const imgData = canvas.toDataURL("image/png");
      const pdf = new jsPDF("p", "mm", "a4");
      const pdfWidth = pdf.internal.pageSize.getWidth();
      const pdfHeight = (canvas.height * pdfWidth) / canvas.width;

      pdf.addImage(imgData, "PNG", 0, 0, pdfWidth, pdfHeight);
      pdf.save(`${certificate?.student?.name || "Student"}_Performance_Transcript.pdf`);
    } catch (error) {
      console.error("Error generating Stats PDF:", error);
    }
  };

  const handleDownloadCertificate = async () => {
    if (!certificateRef.current) return;

    try {
      const canvas = await html2canvas(certificateRef.current, {
        scale: 2, // Improve quality
        useCORS: true, // Handle cross-origin images if any
      });

      const imgData = canvas.toDataURL("image/png");
      const pdf = new jsPDF("l", "mm", "a4"); // Landscape, millimeters, A4
      const pdfWidth = pdf.internal.pageSize.getWidth();
      const pdfHeight = pdf.internal.pageSize.getHeight();

      const imgWidth = canvas.width;
      const imgHeight = canvas.height;
      const ratio = Math.min(pdfWidth / imgWidth, pdfHeight / imgHeight);

      const imgX = (pdfWidth - imgWidth * ratio) / 2;
      const imgY = 0;

      pdf.addImage(imgData, "PNG", imgX, imgY, imgWidth * ratio, imgHeight * ratio);
      pdf.save(`${certificate?.student?.name || "Student"}_Certificate.pdf`);
    } catch (error) {
      console.error("Error generating PDF:", error);
    }
  };
  if (!certificate) return null;

  return (
    <>
      <div className="row g-4 g-xl-5">
        {/* Certificate Image */}
        <div className="col-12 col-xxl-8">
          <div className="card-default-style py-15 py-sm-25 px-15 px-sm-25 px-md-35 px-lg-45">
            <div className="d-flex justify-content-between mb-21">
              <h4 className="ah-heading-lg fw-bold black-100 mb-0">
                Certificate
              </h4>
              {!certificate?.isRequest && (
                <button
                  type="button"
                  onClick={handleDownloadCertificate}
                  className="btn min-w-auto no-shadow p-0 d-flex align-items-center justify-content-center"
                  style={{
                    width: "40px",
                    height: "40px",
                    border: "1px solid #F05203",
                    borderRadius: "8px",
                    backgroundColor: "transparent",
                    color: "#F05203",
                  }}
                  title="Download Certificate"
                >
                  <svg
                    width="20"
                    height="20"
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  >
                    <path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4" />
                    <polyline points="7 10 12 15 17 10" />
                    <line x1="12" y1="15" x2="12" y2="3" />
                  </svg>
                </button>
              )}
            </div>
            <div className="certificate-img-wrapper">
              <div
                ref={certificateRef}
                style={{
                  padding: "40px",
                  backgroundImage: `url(${certificateBg})`,
                  backgroundSize: "100% 100%",
                  backgroundRepeat: "no-repeat",
                }}
              >
                <div
                  style={{
                    backgroundColor: "#fff",
                    width: "100%",
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    padding: "10px",
                    boxSizing: "border-box",
                  }}
                >
                  <div
                    style={{
                      display: "flex",
                      flexDirection: "column",
                      justifyContent: "center",
                      alignItems: "center",
                      textAlign: "center",
                      maxWidth: "730px",
                      height: "545px",
                      width: "100%",
                    }}
                  >
                    <div className="d-flex justify-content-between w-100">
                      <img src={certificateLogo} alt="certificate Logo" style={{ width: "100px", height: "100px" }} />
                      <div>
                        <h2
                          style={{

                            fontSize: "51px",
                            fontWeight: 600,
                            color: "#000000", 
                            margin: "10px 0 5px 0",
                            lineHeight: 1,
                          }}
                        >
                          CERTIFICATE
                        </h2>
                        <span
                          style={{

                            fontSize: "24px",
                            fontWeight: 400,
                            color: "#000000",
                            display: "block",
                            marginBottom: "8px",
                          }}
                        >
                          Of Completion
                        </span>
                        <p
                          style={{

                            fontSize: "16px",
                            fontWeight: 400,
                            color: "#7A7A7A",
                            margin: "0 0 5px 0",
                          }}
                        >
                          This Certificate is proudly Printed to
                        </p>
                      </div>
                      <img src={awardImg} alt="Award" style={{ width: "100px", height: "100px" }} />
                    </div>
                    <h1
                      style={{
                        fontFamily: "'Playfair Display', serif",
                        fontSize: "61px",
                        fontWeight: 400,
                        fontStyle: "italic",
                        color: "#F05203",
                        margin: "0",
                        lineHeight: 1.2, // Increased line-height for better spacing
                        paddingBottom: "5px"
                      }}
                    >
                      {certificate?.student?.name || certificate?.user?.name || "N/A"}
                    </h1>
                    <div
                      style={{
                        width: "100%",
                        height: "1px",
                        backgroundColor: "#4D4D4D80", // Using background-color instead of border-bottom
                        marginTop: "10px",
                        // marginBottom: "15px",
                      }}
                    ></div>

                    <h3
                      style={{

                        fontSize: "20px",
                        fontWeight: 600,
                        color: "#000000",
                        margin: "12px 0 8px 0",
                      }}
                    >
                      {certificate?.course?.title ||
                        "The Education Gaming Wellness Blockchain"}
                    </h3>

                    <p
                      style={{

                        fontSize: "12px",
                        fontWeight: 400,
                        color: "#5A5A5A",
                        lineHeight: 1.5,
                        margin: "0 0 15px 0",
                        textAlign: "justify",
                      }}
                    >
                      {certificate?.performanceDetails?.overview || "N/A"}
                    </p>

                    <div
                      style={{
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "flex-end",
                        marginTop: "15px",
                        gap: "100px",
                        position: "relative"
                      }}
                    >
                      <div style={{ textAlign: "center", flex: 1 }}>
                        <p
                          style={{

                            fontSize: "14px",
                            fontWeight: 600,
                            color: "#000000",
                            margin: "0 0 5px 0",
                          }}
                        >
                          {new Date(certificate?.issueDate || new Date()).toLocaleDateString("en-US", {
                            day: '2-digit', month: 'short', year: 'numeric'
                          }).replace(/\//g, '-')}
                        </p>
                        <div
                          style={{
                            width: "150px",
                            height: "1px",
                            backgroundColor: "#000",
                            margin: "0 auto 3px",
                          }}
                        ></div>
                        <p
                          style={{

                            fontSize: "12px",
                            fontWeight: 400,
                            color: "#000000",
                            margin: "0",
                          }}
                        >
                          Date
                        </p>
                      </div>

                      <div style={{ textAlign: "center", flex: 1 }}>
                        <img src={EgwbSignature} alt="EgwbSignature" className="mx-auto" style={{ width: "100px", marginBottom: "-30px" }} />
                        <div
                          style={{
                            width: "150px",
                            height: "1px",
                            backgroundColor: "#000",
                            margin: "0 auto 3px",
                          }}
                        ></div>
                        <p
                          style={{

                            fontSize: "12px",
                            fontWeight: 400,
                            color: "#000000",
                            margin: "0",
                          }}
                        >
                          Signature
                        </p>
                      </div>
                    </div>
                    <div style={{ marginTop: "20px" }}>
                       <p style={{
                         fontSize: "10px",
                         color: "#7A7A7A",
                         margin: "0",
                         fontFamily: "monospace",
                         letterSpacing: "1px"
                       }}>
                         Verification ID: {certificate?.certificateId || "N/A"}
                       </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Student + Course Info */}
        <div className="col-12 col-xxl-4">
          <h1 className="ah-heading-03 fw-bold black-100 mb-23">
            {certificate?.course?.title || "N/A"}
          </h1>
          <div className="student-info">
            <div className="d-flex align-items-center mb-23">
              <Image
                src={
                  process.env.REACT_APP_GALLERY_URL +
                  "/" +
                  (certificate?.student?.profile_picture ||
                    certificate?.user?.profile_picture)
                }
                onError={(e) => {
                  e.target.onError = null;
                  e.target.src = placeholderImg;
                }}
                className="rounded-circle student-img object-fit-cover flex-shrink-0"
                width={50}
                height={50}
              />
              <h5 className="ah-text-base black-100 mb-0 fw-bold ms-8">
                {certificate?.student?.name || certificate?.user?.name || "N/A"}
              </h5>
            </div>
          </div>

          {/* Performance Stats UI (Visible) */}
          <div className="card-default-style my-30 p-20">
            <h4 className="ah-heading-06 fw-bold black-100 mb-20 border-bottom pb-10">
              Performance Stats
            </h4>

            <div className="row g-3">
              {[
                {
                  label: "Quizzes",
                  value: certificate?.performanceDetails?.activities?.quizzes,
                },
                {
                  label: "Notes",
                  value: certificate?.performanceDetails?.activities?.notes,
                },
                {
                  label: "Flashcards",
                  value:
                    certificate?.performanceDetails?.activities?.flashcardSets,
                },
                {
                  label: "Mindmaps",
                  value: certificate?.performanceDetails?.activities?.mindmaps,
                },
                {
                  label: "Audio",
                  value:
                    certificate?.performanceDetails?.activities?.audioSummaries,
                },
                {
                  label: "Chats",
                  value: certificate?.performanceDetails?.activities?.chats,
                },
                {
                  label: "AssessMe",
                  value:
                    certificate?.performanceDetails?.activities?.assessMeSessions,
                },
                {
                  label: "Growth",
                  value:
                    certificate?.performanceDetails?.activities
                      ?.growthCoordinatorSessions,
                },
              ].map((stat, i) => (
                <div className="col-6" key={i}>
                  <div className="p-12 bg-light rounded-3 text-center h-100 border">
                    <p
                      className="ah-text-xs grey-500 mb-4 text-uppercase fw-semibold"
                      style={{ fontSize: "10px" }}
                    >
                      {stat.label}
                    </p>
                    <p className="ah-text-base fw-bold black-800 mb-0">
                      {stat.value || 0}
                    </p>
                  </div>
                </div>
              ))}
            </div>

            <div className="mt-20 pt-15 border-top">
              <div className="d-flex justify-content-between align-items-center mb-8">
                <span className="ah-text-sm fw-medium grey-600">
                  Assessment
                </span>
                <span
                  className={`ah-text-sm fw-bold ${certificate?.performanceDetails?.assessment?.passed
                    ? "text-success"
                    : "text-danger"
                    }`}
                >
                  {certificate?.performanceDetails?.assessment?.passed
                    ? "PASSED"
                    : "FAILED"}
                </span>
              </div>
              <div className="d-flex justify-content-between align-items-center">
                <span className="ah-text-sm fw-medium grey-600">Final Score</span>
                <span
                  className="ah-text-lg fw-bold theme-color"
                  style={{ fontSize: "20px" }}
                >
                  {certificate?.performanceDetails?.assessment?.final_score || 0}
                  %
                </span>
              </div>
            </div>
          </div>
          {!certificate?.isRequest && (
            <button
              type="button"
              className="btn btn-primary no-shadow w-100 py-5"
             onClick={handleDownloadStats}
            >
              Download Transcript
            </button>
          )}
        </div>
      </div>

      {/* Hidden Academic Transcript (Off-screen for PDF capture) */}
      <div style={{ position: "absolute", left: "-3000px", top: "0", width: "800px" }}>
        <div ref={statsRef} className="p-0 overflow-hidden" style={{ backgroundColor: "#fff", border: "1px solid #e0e0e0" }}>
          {/* Transcript Header */}
          <div className="p-20 text-center" style={{ backgroundColor: "#f8f9fa", borderBottom: "2px solid #F05203" }}>
            <div className="d-flex justify-content-between align-items-center mb-10">
              <img src={certificateLogo} alt="Logo" style={{ width: "60px" }} />
              <div>
                 <h5 className="mb-0 fw-bold" style={{ color: "#F05203", letterSpacing: "1px" }}>{certificate?.branding?.primary || "SkillPath Village™"}</h5>
                 <p className="small text-muted mb-0">{certificate?.branding?.programTitle || "Workforce Readiness"}</p>
              </div>
              <div style={{ width: "60px" }}></div>
            </div>
            <h4 className="fw-bold text-uppercase mt-10 mb-0" style={{ letterSpacing: "2px" }}>Official Academic Transcript</h4>
            <p className="text-muted small">Verification ID: {certificate?.certificateId || "N/A"}</p>
          </div>

          <div className="p-25">
            {/* Student & Course Profile */}
            <div className="row mb-30 pb-20 border-bottom">
              <div className="col-7">
                <h6 className="text-uppercase fw-bold grey-500 small mb-10">Student Profile</h6>
                <div className="d-flex align-items-center">
                  <Image
                    src={process.env.REACT_APP_GALLERY_URL + "/" + (certificate?.student?.profile_picture || certificate?.user?.profile_picture)}
                    onError={(e) => { e.target.onError = null; e.target.src = placeholderImg; }}
                    className="rounded-circle me-15"
                    width={60} height={60}
                    style={{ border: "2px solid #F05203" }}
                  />
                  <div>
                    <h5 className="fw-bold mb-2">{certificate?.student?.name}</h5>
                    <p className="small text-muted mb-0">{certificate?.student?.email}</p>
                  </div>
                </div>
              </div>
              <div className="col-5 border-start ps-20">
                <h6 className="text-uppercase fw-bold grey-500 small mb-10">Course Information</h6>
                <h5 className="fw-bold mb-2">{certificate?.course?.title}</h5>
                <p className="small text-muted mb-0" style={{ fontSize: "11px", wordBreak: "break-word", lineHeight: "1.5", minHeight: "36px", display: "-webkit-box", WebkitLineClamp: 2, WebkitBoxOrient: "vertical", overflow: "hidden" }}>
                  {certificate?.course?.description}
                </p>
              </div>
            </div>

            {/* Competency Summary */}
            <div style={{ marginBottom: "40px" }}>
              <h6 style={{ textTransform: "uppercase", fontWeight: "700", color: "#adb5bd", fontSize: "12px", marginBottom: "20px", letterSpacing: "1px" }}>
                Competency Achievements
              </h6>
              <div style={{ border: "1px solid #edf2f7", borderRadius: "10px", overflow: "hidden shadow-sm" }}>
                <table style={{ width: "100%", borderCollapse: "collapse", backgroundColor: "#fff" }}>
                  <thead>
                    <tr style={{ backgroundColor: "#f8fafc", borderBottom: "1px solid #edf2f7" }}>
                      <th style={{ padding: "2px 15px 15px 15px", textAlign: "left", fontSize: "11px", fontWeight: "700", color: "#64748b", textTransform: "uppercase" }}>Task / Requirement</th>
                      <th style={{ padding: "2px 15px 15px 15px", textAlign: "center", fontSize: "11px", fontWeight: "700", color: "#64748b", textTransform: "uppercase", width: "120px" }}>Status</th>
                      <th style={{ padding: "2px 15px 15px 15px", textAlign: "left", fontSize: "11px", fontWeight: "700", color: "#64748b", textTransform: "uppercase" }}>Performance Details</th>
                    </tr>
                  </thead>
                  <tbody>
                    {certificate?.performanceDetails?.competencySummary?.map((item, idx) => (
                      <tr key={idx} style={{ borderBottom: idx === certificate.performanceDetails.competencySummary.length - 1 ? "none" : "1px solid #f1f5f9" }}>
                        <td style={{ padding: "2px 15px 15px 15px", fontSize: "14px", fontWeight: "600", color: "#1e293b" }}>{item.task}</td>
                        <td style={{ padding: "2px 15px 15px 15px", textAlign: "center" }}>
                          <span style={{ 
                            fontSize: "11px",
                            fontWeight: "700",
                            padding: "0px 15px 8px 15px", 
                            borderRadius: "20px",
                            display: "inline-block",
                            textTransform: "uppercase",
                            backgroundColor: item.status === "Completed" || item.status === "Passed" || item.status === "Verified" ? "#dcfce7" : "#fef3c7",
                            color: item.status === "Completed" || item.status === "Passed" || item.status === "Verified" ? "#15803d" : "#b45309",
                            border: `1px solid ${item.status === "Completed" || item.status === "Passed" || item.status === "Verified" ? "#bbf7d0" : "#fde68a"}`
                          }}>
                            {item.status}
                          </span>
                        </td>
                        <td style={{ padding: "2px 15px 15px 15px", fontSize: "13px", color: "#64748b" }}>{item.details}</td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            </div>

            {/* Detailed Academic Record (Quizzes) */}
            <div style={{ marginBottom: "40px" }}>
              <h6 style={{ textTransform: "uppercase", fontWeight: "700", color: "#adb5bd", fontSize: "12px", marginBottom: "20px", letterSpacing: "1px" }}>
                Detailed Assessment Log
              </h6>
              <div style={{ border: "1px solid #edf2f7", borderRadius: "10px", overflow: "hidden" }}>
                <table style={{ width: "100%", borderCollapse: "collapse" }}>
                  <thead>
                    <tr style={{ backgroundColor: "#1e293b", color: "#fff" }}>
                      <th style={{ padding: "2px 15px 15px 15px", textAlign: "left", fontSize: "11px", fontWeight: "600", textTransform: "uppercase", letterSpacing: "0.5px" }}>Assessment Title</th>
                      <th style={{ padding: "2px 15px 15px 15px", textAlign: "center", fontSize: "11px", fontWeight: "600", textTransform: "uppercase", letterSpacing: "0.5px" }}>Raw Score</th>
                      <th style={{ padding: "2px 15px 15px 15px", textAlign: "center", fontSize: "11px", fontWeight: "600", textTransform: "uppercase", letterSpacing: "0.5px" }}>Percentage</th>
                      <th style={{ padding: "2px 15px 15px 15px", textAlign: "center", fontSize: "11px", fontWeight: "600", textTransform: "uppercase", letterSpacing: "0.5px" }}>Completion Date</th>
                    </tr>
                  </thead>
                  <tbody>
                    {certificate?.performanceDetails?.quizzes?.map((quiz, idx) => (
                      <tr key={idx} style={{ 
                        backgroundColor: idx % 2 === 0 ? "#fff" : "#f8fafc",
                        borderBottom: idx === certificate.performanceDetails.quizzes.length - 1 ? "none" : "1px solid #f1f5f9"
                      }}>
                        <td style={{ padding: "2px 15px 15px 15px", fontSize: "13px", fontWeight: "500", color: "#334155" }}>{quiz.title}</td>
                        <td style={{ padding: "2px 15px 15px 15px", textAlign: "center", fontSize: "13px", color: "#64748b" }}>{quiz.score} / {quiz.total_questions}</td>
                        <td style={{ padding: "2px 15px 15px 15px", textAlign: "center", fontSize: "14px", fontWeight: "700", color: "#F05203" }}>{quiz.percentage}%</td>
                        <td style={{ padding: "2px 15px 15px 15px", textAlign: "center", fontSize: "13px", color: "#64748b" }}>{new Date(quiz.completed_at).toLocaleDateString("en-US", { month: 'short', day: 'numeric', year: 'numeric' })}</td>
                      </tr>
                    ))}
                    {(!certificate?.performanceDetails?.quizzes || certificate.performanceDetails.quizzes.length === 0) && (
                      <tr><td colSpan="4" style={{ textAlign: "center", padding: "30px", fontSize: "14px", color: "#94a3b8", fontStyle: "italic" }}>No detailed assessment records found</td></tr>
                    )}
                  </tbody>
                </table>
              </div>
            </div>

            {/* Final Summary Metrics */}
            <div className="row g-3">
              {[
                { label: "Quizzes", value: certificate?.performanceDetails?.activities?.quizzes },
                { label: "AI Chats", value: certificate?.performanceDetails?.activities?.chats },
                { label: "Evaluations", value: certificate?.performanceDetails?.activities?.assessMeSessions },
                { label: "Guidance", value: certificate?.performanceDetails?.activities?.growthCoordinatorSessions },
              ].map((stat, i) => (
                <div className="col-3" key={i}>
                  <div className="p-10 bg-white rounded border text-center">
                    <p className="text-uppercase grey-500 mb-0 fw-bold" style={{ fontSize: "9px" }}>{stat.label}</p>
                    <p className="mb-0 fw-bold">{stat.value || 0}</p>
                  </div>
                </div>
              ))}
            </div>

            <div className="mt-30 pt-20 border-top d-flex justify-content-between align-items-center">
              <div>
                 <span className="small text-muted text-uppercase fw-bold">Final Academic Status: </span>
                 <span className={`fw-bold ms-10 ${certificate?.performanceDetails?.assessment?.passed ? "text-success" : "text-danger"}`}>
                   {certificate?.performanceDetails?.assessment?.passed ? "DISTINCTION / PASSED" : "FAILED"}
                 </span>
              </div>
              <div className="text-end">
                 <h5 className="fw-bold theme-color mb-0" style={{ fontSize: "28px" }}>
                   {certificate?.performanceDetails?.assessment?.final_score || 0}%
                 </h5>
                 <p className="small text-muted text-uppercase mb-0 fw-bold">Cumulative Weighted Score</p>
              </div>
            </div>
          </div>
          
          {/* Transcript Footer */}
          <div className="p-15 text-center bg-light border-top border-2">
             <p className="small text-muted mb-0" style={{ fontSize: "10px" }}>
               LutinX-Verified Blockchain Security | Academic Record issued by EGWB SkillPath Village
             </p>
          </div>
        </div>
      </div>
    </>
  );
};

export default StudentCertificateDetailComponent;